import { Button, Flex, Input, useToast } from '@chakra-ui/react'
import { useState } from 'react'
import { Card } from '../Card'
import { useMutation } from 'react-query'
import { editInfoEntrega } from '../requests'

export function DeliveryStep({ payment, partner, refetch }) {
  const [codparcDest, setCodparcDest] = useState('')

  const toast = useToast({
    position: 'top-right',
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({ codparcDest, NUNOTA }) => editInfoEntrega(codparcDest, NUNOTA),
    mutationKey: 'edit-info-entrega',
    onSuccess: () => {
      refetch()
      toast({
        title: 'Dados de entrega atualizados com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao atualizar dados de entrega',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    },
  })

  async function handleEditInfoEntrega() {
    await mutateAsync({
      codparcDest,
      NUNOTA: payment.NUNOTA,
    })
  }

  return (
    <Flex flexDir="column" height="100%">
      <Card
        isGreen
        title="DADOS DA ENTREGA"
        razaoSocial={partner?.ent_razao_social}
        cnpj={partner?.ent_cpf_cnpj}
        ie={partner?.ent_inscricao_estadual}
        endereco={partner?.ent_endereco}
        cep={partner?.ent_cep}
        cidade={partner?.ent_cidade}
        estado={partner?.ent_uf}
        nome={partner?.ent_nome}
        email={partner?.ent_email}
        telefone={partner?.ent_fixo}
        celular={partner?.ent_telefone}
      />
      <Flex maxW="300px" mb="1rem" ml="1rem" marginTop="auto">
        <Input placeholder="Parceiro" onChange={(e) => setCodparcDest(e.target.value)} />
        <Button ml="1rem" onClick={() => handleEditInfoEntrega()} isLoading={isLoading} isDisabled={isLoading}>
          Atualizar
        </Button>
      </Flex>
    </Flex>
  )
}
